import {createContext} from 'react';


const I18nContext = createContext({labelI18nInstance: {}});
export default I18nContext;
